import React from 'react';
import { Image, Container } from '@chakra-ui/react';
import ReactPlayer from 'react-player';
import HomeLayout from '../../components/layouts/homelayout';
import PageHeader from '../../components/sections/pageheader';

import TextWithLeftMedia from '../../components/sections/textwithleftmedia';
import TextWithRightMedia from '../../components/sections/textwithrightmedia';
import Carousel from '../../components/sections/carousel';

import LeatherWorkingGroup from '../../components/ui/corporateresponsibility/sustainingplaces/LeatherWorkingGroup.jpg';
import GreenChemistry from '../../components/ui/corporateresponsibility/sustainingplaces/green-chemistry.jpg'; 
import Fishing from '../../components/ui/corporateresponsibility/sustainingplaces/Fishing.jpg';
import PoweringBusiness from '../../components/ui/corporateresponsibility/sustainingplaces/Powering_our_Business_Carousel_Item.jpg';
import Rethreads from '../../components/ui/corporateresponsibility/sustainingplaces/Rethreads.jpg';

import Building from '../../components/ui/corporateresponsibility/responsiblepractices/Building.jpg';


export default function SustainingPlacesTabPanel() {
  const cards = [
    {image: PoweringBusiness, heading: "POWERING OUR BUSINESS AND PRODUCTS WITH CLEAN ENERGY", text: "Reducing our carbon footprint by reducing energy use and increasing the use of renewable energy, both in our owned and operated facilities and in our supply chain."},
    {image: Rethreads, heading: "MAKING RESOURCES LAST LONGER THROUGH RECYCLING & CLOSED LOOP PRACTICES", text: "Recapturing and reusing our finite resources to contribute to a circular system that sustains our planet."},
    {image: GreenChemistry, heading: "ADOPTION OF GREEN CHEMISTRY", text: "Increasing our adoption of sustainable chemistry to reduce risk that hazardous chemicals pose to our workers, consumers and the environment."},
    {image: Fishing, heading: "IMPROVING WATER SUSTAINABILITY", text: "Reducing our water footprint by buying materials that are dyed without water, following strict usage regulations in our mills, and investing in clean water for communities where we manufacture."}
  ];
  return (
    <HomeLayout>
      <title>Corporate Responsibility - Sustaining Places</title>
      <meta name="description" content="Minimizing environmental impact on the planet." />
      <PageHeader 
        heading='Sustaining Places'
        bkgImg={Building}
      />
      <Container maxW='6xl' my={14} className='flow'>
        <Carousel cards={cards} />
        <h2>Featured Initiatives</h2>
        <TextWithRightMedia
            media={<ReactPlayer src="https://www.youtube.com/watch?v=cDW_eHKoLwI" width={'100%'} height={'100%'} style={{'aspect-ratio': '16 / 9'}} />}
            title={<h3>Planet Water</h3>}
            content={<p>Access to clean water is a pressing global issue. We're proud to partner with the Planet Water Foundation, a U.S. nonprofit that helps combat our global water crisis by bringing clean water to the world's most disadvantaged communities.</p>}
            cta_url={"https://planet-water.org/"}
            cta_text={"Read More"}
        />
        <TextWithLeftMedia 
            media={<ReactPlayer src="https://www.youtube.com/watch?v=oa0ybTF_QOU" width={'100%'} height={'100%'} style={{'aspect-ratio': '16 / 9'}} />}
            title={<h3>ReThreads</h3>}
            content={<p>At Columbia Sportswear Company, we are committed to taking a holistic, life cycle approach to managing the environmental impacts of the products we make. This includes extending the life of our products and keeping these products out of landfills once they have reached the end of their wearable life.</p>}
            cta_url={"https://www.columbia.com/ReThreads.html"}
            cta_text={"Read More"}
        />
        <TextWithRightMedia
            media={<Image src={LeatherWorkingGroup}/>}
            title={<h3>Leather Working Group</h3>}
            content={<p>Columbia Sportswear Company is committed to supporting responsible leather manufacturing across the globe, and that is why we are proud members of the Leather Working Group (LWG). The LWG aims to improve the leather manufacturing industry by creating alignment on environmental priorities, bringing visibility to best practices and providing suggested guidelines for continual improvement. In 2021, 100% of our footwear leather manufacturing partners were LWG rated and our team continues to prioritize leather sourcing from LWG tanneries.</p>}
            cta_url={"https://www.leatherworkinggroup.com/"}
            cta_text={"Read More"}
        />
        </Container>
      </HomeLayout>
  );
}